import { ExclamationTriangleFill } from "@styled-icons/bootstrap/ExclamationTriangleFill";
import { Delete, Tick } from "assets/icons/Common";
import { OverlayTrigger } from "react-bootstrap";
import { SaveWordsProps } from "types/GlobalData";

import { TooltipStyled, WordDeleteBtn, WordName, WordsItemBoxStyled } from "../saveWordsList.style";

interface WordsItemBoxProps {
  onOpenDeleteModal: (id: string) => void;
  onAcceptWordList: (id: string) => void;
  word: SaveWordsProps;
  onValidation?: (params?: any) => boolean;
  activeListId: string;
}

const renderTooltip = (props: any) => (
  <TooltipStyled id="button-tooltip" {...props}>
    <ExclamationTriangleFill size={14} fill="black" />
    Some words in this list are too long for this widget. They will be shortened to fit.
  </TooltipStyled>
);

export const WordsItemBox = (props: WordsItemBoxProps) => {
  const { onOpenDeleteModal, word, onAcceptWordList, onValidation, activeListId } = props;

  const isValidList = onValidation ? onValidation({ value: word.words }) : true;

  const handleDelete = () => onOpenDeleteModal(word.id);
  const handleClickItem = () => {
    onAcceptWordList(word.id);
  };
  return (
    <>
      <WordsItemBoxStyled>
        {isValidList ? (
          <WordName title={word.name} onClick={handleClickItem} isActive={activeListId === word.id}>
            <div>
              {isValidList ? null : <ExclamationTriangleFill size={15} />}

              <span>{word.name}</span>
            </div>

            {activeListId === word.id ? <Tick size={15} /> : null}
          </WordName>
        ) : (
          <OverlayTrigger placement="top" overlay={renderTooltip} trigger="focus">
            <WordName
              title={word.name}
              onClick={handleClickItem}
              isActive={activeListId === word.id}
            >
              <div>
                {isValidList ? null : <ExclamationTriangleFill size={15} />}

                <span>{word.name}</span>
              </div>

              {activeListId === word.id ? <Tick size={15} /> : null}
            </WordName>
          </OverlayTrigger>
        )}

        <WordDeleteBtn
          withShadow={false}
          Icon={Delete}
          accentColor="var(--danger)"
          onClick={handleDelete}
        />
      </WordsItemBoxStyled>
    </>
  );
};
